module.exports = __webpack_public_path__ + "img/31_19.43276cd3.png";